// Globals
import { useTranslation } from 'react-i18next';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { changeOrderStatus, completeOrder, selectOrder, selectOrdersIsLoading } from '../../feature';

// Components
import { Button } from '@/ui';
import { AdDetails, StyledTabs } from '../../components';
import { StyledContainer, StyledFooter } from './AdContainerStyles';

// Models
import { EntityType } from '@/models/logs.model';
import { OrderStatus } from '@/models/order.model';

// Modules
import { LogsListContainer } from '@/modules/Logs';

// Helpers
import { getEntityId } from '@/utils';

const AdContainer = () => {
  const { t } = useTranslation('order');
  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectOrdersIsLoading);
  const order = useAppState(selectOrder);
  const handleChangeStatus = (status: OrderStatus) =>
    dispatch(changeOrderStatus({ id: getEntityId(order?.PK ?? ''), status }));

  const handleCompleteOrder = () => dispatch(completeOrder({ id: getEntityId(order?.PK ?? '') }));

  if (!order) return null;

  const canCompleteOrder = order.status === OrderStatus.IN_PROGRESS;

  return (
    <StyledTabs
      destroyInactiveTabPane
      items={[
        {
          key: 'details',
          label: t('details'),
          children: (
            <>
              <StyledContainer>
                <AdDetails isLoading={isLoading} order={order} onChangeStatus={handleChangeStatus} />
              </StyledContainer>
              {canCompleteOrder && (
                <StyledFooter>
                  <Button type="primary" shape="round" onClick={handleCompleteOrder}>
                    {t('complete')}
                  </Button>
                </StyledFooter>
              )}
            </>
          ),
        },
        {
          key: 'logs',
          label: t('logs'),
          children: <LogsListContainer id={order?.PK ?? ''} entityType={EntityType.ORDER} />,
        },
      ]}
    />
  );
};

export default AdContainer;
